import React from 'react';
import $ from 'jquery';


export default class XeditableTextField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: 'inline',
      refresh: undefined, // used to redraw the component
    }
  }

  componentDidMount = () => {
    //setTimeout(() => this.renderEditable(), 1000 );
    setTimeout(() => this.renderEditable(), 500 );

  }

  componentWillReceiveProps = (nextProps) => {
    setTimeout(() => this.renderEditable(), 500 );
  }

  renderEditable = () => {
    $(`.${this.props.reference}`).editable({
      showbuttons : true,
      mode: 'inline',
      type: 'text',
      success: function(response, newValue) {
        //console.log('here is xeditable id');
        let id = $(this).data('pk').split('-')[0];
        //console.log(id);
        //console.log('here is xeditable field');
        let field = $(this).data('pk').split('-')[1];
        //console.log(field);
        //console.log('here is xeditable app');
        let model= $(this).data('pk').split('-')[2]
        //console.log(model);
        //console.log('here is xeditable model');
        let app = $(this).data('pk').split('-')[3]
        //console.log(app)

        let cookie;
        let c_name = 'csrftoken';

        if(document.cookie.length > 0) {
            let c_start = document.cookie.indexOf(c_name + "=");
            if(c_start != -1) {
                c_start = c_start + c_name.length + 1;
                let c_end = document.cookie.indexOf(";", c_start);
                if(c_end == -1) c_end = document.cookie.length;
                cookie = unescape(document.cookie.substring(c_start,c_end));
            }
        } else {
            cookie = "";
        }

        $.ajax({
            url: '/api/xeditable/' + app + '/' + model + '/?limit=1&id=' + id,
            dataType: 'json',
            headers: {"X-CSRFToken": cookie},
            cache: false,
            //headers: {'Authorization': 'Token ' + localStorage.token},
            success: (data) => {
              //console.log('Xeditable got the instance');
              //console.log(data.results);
              //console.log('Here is the data results [0]');
              //console.log(data.results[0]);
              let instance = data.results[0];
              instance[field] = newValue;
              $.ajax({
                  url: '/api/xeditable/' + app + '/' + model + '/' + id + '/',
                  dataType: 'json',
                  headers: {"X-CSRFToken": cookie},
                  method: 'PUT',
                  data: instance,
                  //headers: {'Authorization': 'Token ' + localStorage.token},
                  success: (data) => {
                    // We submitted the change.
                    //console.log('Yay, we submitted a change.')
                  }
              })
            },
            error: (xhr, status, err) => {
              //console.log(err.toString())
            }
        });
      }
    });
  }

  render() {
    return (
      <a
        href='#'
        className={`${this.props.reference}`}
        data-pk={`${this.props.reference}`}
        key={this.props.refresh}
        data-type='text'
      >
      {this.props.value}
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/helpers/field/xeditable/xeditable_text_field.js